export const alerts = {
  acknowledgeAgreement:
    "I acknowledge that all clinical pathways have been followed for this alert.",
  noAlertsForPatient: "There are no alerts for this patient."
};
